var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMarginTradingNav = function SvgMarginTradingNav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#33658A",
    d: "M26 0a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6h20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M22.5 18a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm0 2a2.5 2.5 0 0 0 0 5 2.5 2.5 0 0 0 0-5zM9.5 5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm0 2a2.5 2.5 0 0 0 0 5 2.5 2.5 0 0 0 0-5zm14.793-.707a1 1 0 0 1 1.497 1.32l-.083.094-18 18a1 1 0 0 1-1.497-1.32l.083-.094 18-18z"
  }))));
};

export { SvgMarginTradingNav as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGcgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzMzNjU4QSIgZD0iTTI2IDBhNiA2IDAgMCAxIDYgNnYyMGE2IDYgMCAwIDEtNiA2SDZhNiA2IDAgMCAxLTYtNlY2YTYgNiAwIDAgMSA2LTZoMjB6Ii8+PHBhdGggZmlsbD0iI0ZGRiIgZD0iTTIyLjUgMThhNC41IDQuNSAwIDEgMSAwIDkgNC41IDQuNSAwIDAgMSAwLTl6bTAgMmEyLjUgMi41IDAgMCAwIDAgNSAyLjUgMi41IDAgMCAwIDAtNXpNOS41IDVhNC41IDQuNSAwIDEgMSAwIDkgNC41IDQuNSAwIDAgMSAwLTl6bTAgMmEyLjUgMi41IDAgMCAwIDAgNSAyLjUgMi41IDAgMCAwIDAtNXptMTQuNzkzLS43MDdhMSAxIDAgMCAxIDEuNDk3IDEuMzJsLS4wODMuMDk0LTE4IDE4YTEgMSAwIDAgMS0xLjQ5Ny0xLjMybC4wODMtLjA5NCAxOC0xOHoiLz48L2c+PC9zdmc+";